import React, {useState} from 'react';


export default function DecisionGame({scenario, img1, img2, explanation1, explanation2, reverse}) {
    const orientation = reverse ? "row-reverse" : "row";
    const [result, setResult] = useState("");
    const [explanation, setExplanation] = useState("");

    function handleChoice(choice) {
        if (choice) {
            setResult("Correct!");
            setExplanation(explanation1);
        } else {
            setResult("Not Quite!");
            setExplanation(explanation2);
        }
    }

    return (
        <div className="decision-game center" style={{backgroundColor: "rgb(48, 47, 47)", fontFamily: "'Courier New', Courier, monospace", padding: "20px"}}>
            <p style={{fontFamily: "'Courier New', Courier, monospace", color: "white"}}>{scenario}</p>
            <div className='row' style={{flexDirection: orientation, justifyContent: "center", gap: "10px"}}>
                <img src={img1} alt="Decision game" onClick={() => handleChoice(true)} style={{cursor: "pointer", maxWidth: "46%"}}/>
                <img src={img2} alt="Decision game" onClick={() => handleChoice(false)} style={{cursor: "pointer", maxWidth: "46%"}}/>
            </div>
            <div className='explanation' >
                <p style={{fontFamily: "'Courier New', Courier, monospace", color: "white"}}>{result}</p>
                <p style={{fontFamily: "'Courier New', Courier, monospace", color: "white"}}>{explanation}</p>
            </div>
        </div>
    )

}